import Input from "@/components/controls/input";
import Button from "@/components/controls/button";
import ShadowScrollContainer from "@/components/shadow-scroll-container";
import ColumnsForm from "../form";

export default {
    name: "table-columns-modal",

    props: ["columns", "defaultSelected", "blockedColumns", "columnsCount"],

    components: {
        "c-input": Input,
        "c-button": Button,
        ShadowScrollContainer,
        ColumnsForm,
    },

    data() {
        return {
            isOpen: false,
            search: "",
            selected: [],
        };
    },

    methods: {
        open(selected) {
            this.search = "";
            this.selected = selected;
            this.isOpen = true;
        },

        close() {
            this.isOpen = false;
        },

        apply() {
            this.$emit("apply", this.selected);
            this.close();
        },

        reset() {
            this.close();
        },
    },
};
